import React, { useState } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { backend } from '../config';
import { showNotification } from '../helper/showNotification';

const endpoint = '/api/auth/login';

const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const login = async (password: string) => {
    const result = await fetch(backend.url + endpoint, {
      method: 'POST',
      body: JSON.stringify({ password }),
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (result.status === 401) {
      showNotification('Falsches Passwort', 'warn');
      return;
    }

    if (result.status !== 200) {
      showNotification('Etwas ist schiefgelaufen', 'error');
      return;
    }

    // Status === 200
    setIsLoggedIn(true);
  };

  const logout = () => {
    // TODO: Handle invalidating http-only cookie
    setIsLoggedIn(false);
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
